import qs from 'qs'
import { post,ajaxParam } from '@/units/request.js'
export default {
	data(){
		return {
			circleId: '',
			postCategoryList: []
		}
	},
	methods: {
		//获取帖子分类
		async getPostCategory(){
			let param = {
				circleId: this.circleId
			}
			ajaxParam(param)
			const res = await post('v1/circle/circlePostCategory', qs.stringify(param))
			if(res.data.code==200){
				this.postCategoryList = res.data.list
			} else {
				this.$message.error(res.data.msg)
			}
		},
	}
}